module.exports = __webpack_public_path__ + "signin-background.7bf53aa9eaf0cfe61ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signin-background.jpg
// module id = ./src/assets/img/signin-background.jpg
// module chunks = 1